import { theme } from "@/theme";
import { Arrows, Dots, CarouselProps } from "./Carousel.types";

export const getArrowShape = (arrowsVariant: Arrows["variant"]) => {
  switch (arrowsVariant) {
    case undefined:
    case "white-icon":
    case "blue-icon":
      return "none";
    case "blue-circle":
      return "circle";
  }
};

export const getArrowColor = (arrowsVariant: Arrows["variant"]) => {
  switch (arrowsVariant) {
    case undefined:
    case "blue-circle":
    case "white-icon":
      return "white";
    case "blue-icon":
      return "blue";
  }
};

export const getArrowPadding = (arrowsGutter: Arrows["gutter"]) => {
  switch (arrowsGutter) {
    case undefined:
    case "none":
      return theme.spacing(0);
    case "sm":
      return theme.spacing(6);
    case "md":
      return theme.spacing(7);
    case "lg":
      return theme.spacing(8);
    case "xl":
      return theme.spacing(13);
  }
};

export const getDotsPadding = (dotsGutter: Dots["gutter"]) => {
  switch (dotsGutter) {
    case undefined:
    case "none":
      return theme.spacing(0);
    case "sm":
      return theme.spacing(2.5);
    case "lg":
      return theme.spacing(6.8);
  }
};

export const getDotsPlacement = (dotsPlacement: Dots["placement"]) => {
  switch (dotsPlacement) {
    case undefined:
    case "bottom":
      return { justifyContent: "center" };
    case "bottom-left":
      return { justifyContent: "flex-start" };
    case "bottom-right":
      return { justifyContent: "flex-end" };
  }
};

export const getSlidePositioning = (
  slidePosition: CarouselProps["slidePosition"]
) => {
  switch (slidePosition) {
    case undefined:
    case "center":
      return { alignItems: "center" };
    case "top":
      return { alignItems: "flex-start" };
    case "bottom":
      return { alignItems: "flex-end" };
    case "stretch":
      return { alignItems: "stretch" };
  }
};
